import React from 'react';

// Components
import InvisibleButton from './InvisibleButton';
import { Typography } from '@capintel/component-lib/typography';
import { Stack } from '@capintel/component-lib/stack';

type Props = {
  ariaLabel?: string;
  children?: JSX.Element | JSX.Element[];
  className?: string;
  title: string;
  description?: string;
  onClick: () => void;
};

const ActionCardButton = ({ ariaLabel, children, className = '', title, description, onClick }: Props) => (
  <InvisibleButton onClick={onClick} ariaLabel={ariaLabel ?? title} className={`${className} action-card-button`}>
    <div className="card">
      {children}
      <div className="card-body">
        <Stack gap="100">
          <Typography variant="headerXs" as="h5">
            {title}
          </Typography>
          {description && (
            <Typography variant="bodyMdRegular" as="p">
              {description}
            </Typography>
          )}
        </Stack>
      </div>
    </div>
  </InvisibleButton>
);

export default ActionCardButton;
